module.exports = __webpack_public_path__ + "static/media/educationplus.f38ef46a.svg";